export const demandeConstants = {
    GETDEMANDE_REQUEST: 'GET_DEMANDE_REQUEST',
};
